// Libs
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useMediaQuery, useObserver } from "@shoothill/core";
import { ApplicationStepEnum } from "Globals/Models/ApplicationStepEnum";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { Section } from "Globals/Models/Section";
// Styles
import { theme } from "Globals/Styles/AppTheme";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import AmendmentViewModel from "Globals/ViewModels/Applicant/AmendmentViewModel";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import React, { useState } from "react";
import styled from "styled-components";
import { StepView } from "Views/Application/StepView";
// App
import { IAccordionControls } from "../ApplicationFormView";
import { StoresInstance } from "Globals/Stores";
import { SaveStore } from "Globals/Stores/Domain";
const saveStore: SaveStore = StoresInstance.Domain.SaveStore;

export const StyledAccordion = styled(Accordion)`
    box-shadow: none;
    background-color: transparent;
    min-height: 39px;

    @media (max-width: 768px) {
        min-height: 48px;
    }
`;
export const StyledAccordionSummary = styled(AccordionSummary)`
    background-color: ${theme.palette.hightownBlue.main};
    color: ${theme.palette.common.white};
    font-weight: bold;
    margin-bottom: 15px;
    min-height: 39px;
    .MuiAccordionSummary-content.Mui-expanded {
        margin: 0px;
    }
    .Mui-expanded {
        min-height: 0px;
    }
    @media (max-width: 768px) {
        min-height: 48px;
        padding: 8px 20px;
    }
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
    background-color: ${theme.palette.background.default};
    padding: 0;
`;
interface IProps {
    accordionControls: IAccordionControls;
    applicationFormViewModel: ApplicationFormViewModel;
    step: ApplicationStepEnum;
    sections: Section[];
    showProceedButton: boolean;
    onProceedClick?: () => void;
    hasErrors: boolean[];
    handleCheckSectionsErrors: () => Promise<boolean>;
}

export const StepContainer: React.FC<IProps> = (props: IProps) => {
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    // Accordion Controlls
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const getAmendmentViewModle = (applicant: ApplicantViewModel, section: FormSectionsEnum): AmendmentViewModel | undefined => {
        return applicant.amendmentsViewModel.amendmentViewModels.find((a) => a.model.formSection === section);
    };

    return useObserver(() => (
        <>
            <StepView stepNumber={props.step} style={{ marginBottom: "15px" }} />
            {props.sections.map((section: Section, index: number) => {
                let hasAmendment = false;
                props.applicationFormViewModel.getSortedApplicantViewModels.forEach((applicant) => {
                    let vm = getAmendmentViewModle(applicant, section.formSection);
                    if (vm && vm.model.amendmentNotes != "") {
                        hasAmendment = true;
                    }
                });
                let hasOwnedPropertyInUKorAbroad = props.applicationFormViewModel.getSortedApplicantViewModels.some((applicant) => {
                    return applicant.personalDetailsViewModel.model.hasOwnedPropertyInUKorAbroad == true;
                });
                let showCurrentSection =
                    section.formSection != FormSectionsEnum.CurrentPropertyDetails ||
                    (section.formSection == FormSectionsEnum.CurrentPropertyDetails && hasOwnedPropertyInUKorAbroad == true);

                if (showCurrentSection == false) {
                    props.applicationFormViewModel.getSortedApplicantViewModels.forEach((applicant) => {
                        applicant.updateSectionCompleted(FormSectionsEnum.CurrentPropertyDetails, true);
                        applicant.currentPropertyDetailsViewModel.model.clearData();
                    });
                }

                if (section.formSection == FormSectionsEnum.SupportingInformation) {
                    if (props.applicationFormViewModel.model.requestedSupportingInfo == false) {
                        showCurrentSection = false;
                    }
                }

                console.log("props.applicationFormViewModel.model.requestedSupportingInfo: " + props.applicationFormViewModel.model.requestedSupportingInfo);
                console.log("Form: " + props.applicationFormViewModel.model.id + " - section" + section.title + " - showCurrentSection: " + showCurrentSection);

                return useObserver(() => (
                    <>
                        {showCurrentSection && (
                            <StyledAccordion
                                expanded={props.accordionControls.expanded === section.formSection}
                                square
                                onChange={props.accordionControls.handleChange(section.formSection)}
                                key={`section-accordion-${section.title}-${index}${section.formSection}`}
                            >
                                <StyledAccordionSummary
                                    expandIcon={<ExpandMoreIcon style={{ color: theme.palette.common.white }} />}
                                    aria-controls={`${section.formSection}bh-content`}
                                    id={`${section.formSection}bh-header`}
                                    style={props.hasErrors[section.formSection] ? { backgroundColor: "#DC3545" } : {}}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                                        <Typography style={isMobile ? { fontSize: "16px" } : {}}>{section.title}</Typography>
                                        {hasAmendment && <Typography style={{ padding: "4px 18px", backgroundColor: "#DC3545" }}>Amendment required</Typography>}
                                        {props.hasErrors[section.formSection] && <Typography>Missing required information</Typography>}
                                    </div>
                                </StyledAccordionSummary>
                                <StyledAccordionDetails style={{ display: "block" }}>
                                    {props.applicationFormViewModel.getSortedApplicantViewModels.map((applicant: ApplicantViewModel, index: number) => {
                                        // For the New Property Details we only want to show the first Applicant.
                                        // Applicant 2 will always have the same details.
                                        // Task 7672
                                        if (section.formSection === FormSectionsEnum.NewPropertyDetails) {
                                            if (index > 0) {
                                                return <div></div>;
                                            }
                                        }

                                        const amendmentViewModel = getAmendmentViewModle(applicant, section.formSection);

                                        const isPrimaryApplicant = (): boolean => {
                                            let applicants = props.applicationFormViewModel.applicantViewModels;
                                            let firstApplicant = applicants.find((a) => a.model.primaryApplicant);
                                            if (firstApplicant) {
                                                if (applicant.model.id == firstApplicant.model.id) return true;
                                            }
                                            return false;
                                        };

                                        const getPrimaryApplicant = (): ApplicantViewModel | undefined => {
                                            let applicants = props.applicationFormViewModel.applicantViewModels;
                                            let primaryApplicant = applicants.find((a) => a.model && a.model.primaryApplicant);
                                            return primaryApplicant;
                                        };

                                        const showSection = (): boolean => {
                                            if (section.formSection != FormSectionsEnum.CurrentPropertyDetails && section.formSection != FormSectionsEnum.NewPropertyDetails) {
                                                return true;
                                            }

                                            if (section.formSection === FormSectionsEnum.CurrentPropertyDetails) {
                                                return applicant.personalDetailsViewModel.getValue("hasOwnedPropertyInUKorAbroad");
                                            }

                                            if (isPrimaryApplicant() == true) return true;

                                            let primaryApplicant = getPrimaryApplicant();
                                            if (primaryApplicant != undefined) {
                                                return !primaryApplicant.model.newPropertyDetailsModel.sameForApplicantTwo;
                                            }

                                            return false;
                                        };

                                        return (
                                            <>
                                                {showSection() && (
                                                    <StyledAccordion
                                                        expanded={expanded === `applicant${applicant.model.applicantNumber}`}
                                                        square
                                                        onChange={handleChange(`applicant${applicant.model.applicantNumber}`)}
                                                        key={`applicant-accordion-${section.title}-${index}${section.formSection}`}
                                                    >
                                                        <StyledAccordionSummary
                                                            style={{
                                                                minHeight: "39px",
                                                                backgroundColor: `${theme.palette.common.white}`,
                                                                color: theme.palette.common.black,
                                                                fontWeight: "bold",
                                                            }}
                                                            expandIcon={<ExpandMoreIcon style={{ color: theme.palette.common.black }} />}
                                                            aria-controls={`applicant${applicant.model.applicantNumber}bh-content`}
                                                            id={`applicant${applicant.model.applicantNumber}bh-header`}
                                                        >
                                                            <Typography>Applicant {applicant.model.applicantNumber}</Typography>
                                                        </StyledAccordionSummary>
                                                        <AccordionDetails style={{ display: "block", backgroundColor: theme.palette.background.default }}>
                                                            {amendmentViewModel != undefined && amendmentViewModel.model.amendmentNotes && (
                                                                <Box style={{ padding: "15px", backgroundColor: "#DC3545" }}>
                                                                    <h3 style={{ fontSize: "18px", fontWeight: "bold", color: theme.palette.common.white }}>Amendment required</h3>
                                                                    {amendmentViewModel != undefined && (
                                                                        <p style={{ fontSize: "14px", color: "white" }}>{amendmentViewModel.model.amendmentNotes}</p>
                                                                    )}
                                                                </Box>
                                                            )}
                                                            <section.component applicant={applicant} applicationFormViewModel={props.applicationFormViewModel} />
                                                        </AccordionDetails>
                                                    </StyledAccordion>
                                                )}
                                            </>
                                        );
                                    })}
                                </StyledAccordionDetails>
                            </StyledAccordion>
                        )}
                    </>
                ));
            })}
            {props.showProceedButton == true && (
                <StyledButton
                    style={isMobile ? { margin: "15px 0px", width: "100%", fontSize: "16px", height: "48px" } : { margin: "15px 0px" }}
                    onClick={() => {
                        let isComplete = true;

                        props.sections.map((s) => {
                            props.applicationFormViewModel.applicantViewModels.map((a, index) => {
                                if (a.getSectionsCompleted[s.formSection] === false) {
                                    console.log("Form section " + s.formSection + " is incomplete for " + s.title);
                                    if (s.formSection === FormSectionsEnum.CurrentPropertyDetails) {
                                        if (a.personalDetailsViewModel.getValue("hasOwnedPropertyInUKorAbroad") === false) {
                                            a.updateSectionCompleted(s.formSection, true);
                                        } else {
                                            isComplete = false;
                                        }
                                    } else {
                                        isComplete = false;
                                    }
                                }
                            });
                        });

                        console.log("Is complete? " + isComplete);

                        if (isComplete) {
                            props.onProceedClick ? props.onProceedClick() : null;
                            props.accordionControls.setExpanded(false);
                        } else {
                            props.handleCheckSectionsErrors();
                        }
                    }}
                    disabled={!saveStore.isSaved}
                >
                    {saveStore.isSaved ? <>Proceed to step {props.step + 1}</> : <>Saving...</>}
                </StyledButton>
            )}
        </>
    ));
};
